import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';

export const styles = StyleSheet.create({
  button: {
    backgroundColor: 'transparent',
  },
  buttonHover: {
    backgroundColor: Buttons.ghostBlack.ButtonGhostBlackBackgroundHover,
  },
  buttonPressed: {
    backgroundColor: Buttons.ghostBlack.ButtonGhostBlackBackgroundPressed,
  },
  buttonFocus: {
    backgroundColor: 'transparent',
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: 'transparent',
  },

  icon: {
    color: Buttons.ghostBlack.ButtonGhostBlackIconDefault,
  },
  iconHover: {
    color: Buttons.ghostBlack.ButtonGhostBlackIconDefault,
  },
  iconPressed: {
    color: Buttons.ghostBlack.ButtonGhostBlackIconDefault,
  },
  iconDisabled: {
    color: Buttons.ghostBlack.ButtonGhostBlackIconDisable,
  },
  iconFocus: {
    color: Buttons.ghostBlack.ButtonGhostBlackIconDefault,
  },
});
